const Constants = {
  UNVERIFIED_USER: 'UNVERIFIED_USER : User needs to authenticate',
};

export default Constants;
